import React, { Component } from "react";
import classNames from "classnames";

import styles from "./InternalLoadLink.css";

class InternalLoadLink extends Component {

  render() {
    return (
      <a role={STREAM_REFACTOR ? undefined : "button"}
        name={this.props.name}
        href={this.props.href}
        className={classNames(styles.root, this.props.className, this.props.identifier)}>
        {this.props.children}
      </a>
    );
  }
}

export default InternalLoadLink;
